module.exports = __webpack_public_path__ + "static/media/149316.47024ab5.svg";